<template>
    <div>
        <el-table :data="tbpg.tableData" border height="611">
            <el-table-column prop="poolName" label="流量池名称 "></el-table-column>
            <el-table-column prop="agentName" label="所属代理商"></el-table-column>
            <el-table-column prop="createTime" label="创建时间 "></el-table-column>
            <el-table-column prop="totalFlow" label="总流量（M）"></el-table-column>
            <el-table-column prop="useFlow" label="已使用流量（M）"></el-table-column>
            <el-table-column label="剩余流量（M）">
                <template slot-scope="scope">
                    <span v-if="scope.row.totalFlow>0 && scope.row.useFlow/scope.row.totalFlow>0.85" style="color: red;">{{scope.row.remainsFlow}}</span>
                    <span v-else>{{scope.row.remainsFlow}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.isSold == 2" type="text" @click="showFluxPoolDistribute(scope.row)">分配</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>
        <el-dialog title="流量池分配" :visible.sync="poolVisibale" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="poolForm" :model="poolForm" label-width="120px">
                <el-form-item label="代理商：" prop="agentId">
                    <el-select v-model="poolForm.agentId" filterable>
                        <el-option v-for="item in agentsOption" :value="item.id" :key="item.id" :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="surePoolDistribute">确 定</el-button>
            </div>
        </el-dialog> 

    </div>
</template>
<script>
import {getAgentfluxPoolList, fluxPoolDistribute} from '@/api/fluxPool.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            searchForm: {
                
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
            poolVisibale: false,
            agentsOption: [],
            poolForm: {
                id: null,
                agentId: ''
            }
        }
    },
    methods: {
        cancel(){
            this.poolVisibale = false;
            this.$refs.poolForm.resetFields();
        },
        getAgentfluxPoolListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);            
            getAgentfluxPoolList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        showFluxPoolDistribute(row){
            this.poolVisibale = true;
            common.getNextAgentOptsCom(this, 'agentsOption')
            this.poolForm.id = row.id
        },
        surePoolDistribute(){
            var data = this.poolForm
            fluxPoolDistribute(data).then(res => {
                if(res.data.code == 200){
                    this.poolVisibale = false;
                    this.getAgentfluxPoolListHandler();
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getAgentfluxPoolListHandler();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getAgentfluxPoolListHandler();
        }  
    },
    created(){
        this.getAgentfluxPoolListHandler();
    }
}
</script>